import { container, lazyInject } from '@intelingu/core/IoC/container';
import {observable, reaction, when} from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { CardType, ExplanationCardModel } from '@intelingu/core/interfaces/models/CardModel';
import { AppStore } from '../../../stores/AppStore';
import { CardStore } from '@intelingu/core/stores/CardStore';
import { FinishedLegModal } from '../../partials/FinishedLegModal';
import { FinishedMilestoneModal } from '../../partials/FinishedMilestoneModal';
import { LoadingIndicator } from '../../partials/LoadingIndicator';
import { ProgressBarModal } from '../../partials/ProgressBarModal';
import { SkipTopicModal } from '../../partials/SkipTopicModal';
import { CardControls } from './CardControls';
import { ExerciseCard } from './exercise/ExerciseCard';
import { TopicOverviewCard } from './topic/TopicOverviewCard';
import { TopicStack } from './TopicStack';
import { VocabularyCard } from './vocabulary/VocabularyCard';
import {TrainingModal} from "../../partials/TrainingModal";
import Joyride from 'react-joyride';
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import withTranslation from "@intelingu/core/utils/withTranslation";
import {Link} from "react-router-dom";

export interface CardComponentProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class CardComponent extends Component<CardComponentProps, any> {

    bufferReaction;

    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(AppStore) appStore: AppStore;
    @observable isReady = false;

    async componentDidMount() {
        if (window.location.href.includes('previewCardId')) {
            const parts = window.location.href.split('=');

            const card = await this.cardStore.loadCardPreview(Number(parts[parts.length - 1]));
            this.isReady = true;
        } else {
            await this.cardStore.loadCard();
            this.isReady = true;

            this.bufferReaction = reaction(() => this.cardStore.isBufferLoaded, (value) => {
                if (value) {
                    this.appStore.tourTrigger(this.cardStore.currentCard?.id, 'nextPreloaded');
                }
            });

            this.appStore.tourTrigger(this.cardStore.currentCard?.id, 'nextPreloaded');

            this.triggerCardLoaded();
        }

        this.cardStore.playLegAudioCallback = () => {
            this.appStore.audioLegRef.currentTime = 0;
            this.appStore.audioLegRef.play();
        };
    }

    async componentDidUpdate() {
        this.triggerCardLoaded();
    }

    triggerCardLoaded() {
        if (this.cardStore.currentCard && this.cardStore.currentCard?.id !== this.appStore._tourCurrentCardId) {
            this.appStore.tourTrigger(this.cardStore.currentCard?.id, 'cardLoaded');
        }
    }

    _renderCurrentCard() {
        const { currentCard } = this.cardStore;

        if (!currentCard || !currentCard.card_type) {
            return null;
        }

        if ((currentCard as ExplanationCardModel).is_first_topic_show) {
            return <TopicOverviewCard id={currentCard.id} />;
        }

        switch (currentCard.card_type) {
            case CardType.VOCABULARY:
                return <VocabularyCard id={currentCard.id} key={currentCard.id} />;
            case CardType.EXPLANATION:
            case CardType.EXERCISE:
                return <ExerciseCard id={currentCard.id} key={currentCard.id} />
        }
    }

    render() {
        const { t } = this.props;

        if (!this.isReady) {
            return null;
        }

        if (this.cardStore.currentCard && this.cardStore.currentCard.expired) {
            return <div style={{ display: 'block' }}>
                <div className={'course-card topic-overview-card'}>
                    <div className={'block'}>
                        <div className={'content'} style={{ color: '#fff', paddingTop: 50, paddingLeft: 20, paddingRight: 20 }}>
                            <h1>Dein tägliches Pensum wurde überschritten</h1>

                            <p style={{ textAlign: 'center' }}>In der kostenlosen Version ist das tägliche erlaubte Trainings-Pensum eingeschränkt.&nbsp;
                                <a href={'/subscriptions'} target={'_blank'}>Klicke hier</a>, um dir die Vollversion zu sichern und Intelingu völlig uneingeschränkt zu nutzen.</p>
                        </div>
                    </div>

                    <div className={'choices'}>
                        <a href={'/'} className={'red-button'}>{ t('noMoreCardsButton') }</a>
                    </div>
                </div>
            </div>
        }

        if (!this.cardStore.currentCard) {
            return <div className={'course-card topic-overview-card'}>
                <div className={'block'}>
                    <div className={'content'} style={{ paddingTop: 50, paddingLeft: 20, paddingRight: 20 }}>
                        <h1>{ t('noMoreCardsTitle') }</h1>

                        <p style={{ textAlign: 'center' }}>{ t('noMoreCardsContent') }</p>
                    </div>
                </div>

                <div className={'choices'}>
                    <a href={'/'} className={'red-button'}>{ t('noMoreCardsButton') }</a>
                </div>
            </div>
        }

        return <>
            <CardControls />
            <SkipTopicModal />

            <FinishedLegModal />
            <ProgressBarModal />

            { this._renderCurrentCard() }

            <LoadingIndicator />
            <TopicStack />

            <TrainingModal />

            <div className={'hidden'}>
                <audio ref={elm => this.appStore.audioLegRef = elm}
                       className={'invisible-audio'}
                       autoPlay={false}
                       controls>
                    <source src={require(`assets/sounds/leg-finished.mp3`)} />
                </audio>

                <audio ref={elm => this.appStore.audioSuccessRef = elm}
                       className={'invisible-audio'}
                       autoPlay={false}
                       controls>
                    <source src={require(`assets/sounds/success-part.mp3`)} />
                </audio>

                <audio ref={elm => this.appStore.audioSuccessFullRef = elm}
                       className={'invisible-audio'}
                       autoPlay={false}
                       controls>
                    <source src={require(`assets/sounds/success-full.mp3`)} />
                </audio>
            </div>
        </>
    }

    componentWillUnmount(): void {
        if (this.bufferReaction) {
            this.bufferReaction();
        }
    }

}
